export const BREAK_POINTS = {
    xs: '480px',
    sm: '767px',
    md: '1024px',
    lg: '1280px',
    xl: '1440px',
    xxl: '1920px',
};
